import { IDefineCommand, IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';
import { IAPSclOptionsDatasource } from './../datasources/scl_options_datasource';

interface ISCLSearchConfigField {
  id: number;
  name: string;
  render_type: string;
  options?: string | Record<number, Record<string, string>>;
}

interface ISCLSearchConfigResponse {
  fields: ISCLSearchConfigField[];
}

export type ILoadSclSearchConfigCommand = () => ng.IPromise<IQuery[]>;

angular
  .module('capability-ng-academic-planner')
  .service(
    'loadSclSearchConfigCommand',
    function loadSclSearchConfigCommandDefinition(
      $http: ng.IHttpService,
      defineCommandORM: IDefineCommand,
      appConfigModel: any,
      $q: ng.IQService,
      ngAPSclOptionsDatasource: IAPSclOptionsDatasource,
      log: any
    ) {
      return defineCommandORM('loadSclSearchConfigCommand', function loadSclSearchConfigCommand(deferred) {
        const isSmartCatalogEnabled = appConfigModel.isFeatureEnabled('academicplan-smart_catalog');
        if (!isSmartCatalogEnabled) {
          return deferred.resolve();
        }

        $http
          .get(`academicplan/course_search_fields/`)
          .then((response: ng.IHttpPromiseCallbackArg<ISCLSearchConfigResponse>) => {
            if (!response.data) {
              return deferred.resolve();
            }
            const fieldWithOptions = response.data.fields.filter(
              (field) => _4.includes(['combobox', 'dropdown'], field.render_type) && _4.isString(field.options)
            );

            const promises: Array<ng.IPromise<any>> = [];
            fieldWithOptions.forEach((field, index) => {
              if (_4.isString(field.options)) {
                promises.push(
                  $http.get(field.options.replace(`/api/v1/`, '')).then((res: ng.IHttpPromiseCallbackArg<any>) => {
                    ngAPSclOptionsDatasource.write([
                      {
                        id: index,
                        name: field.name,
                        options: res.data
                      }
                    ]);
                  })
                );
              }
            });
            return $q.all(promises).then(deferred.resolve);
          })
          .catch((e) => {
            log.issue('failed to fetch the course search fields for SCL');
            deferred.reject(e.data);
          });
      });
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/smart_catalog/commands/load_scl_search_config_command.ts